import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=28c65df4"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c65df4')) {
      api.createRecord('28c65df4', component.options)
    } else {
      api.reload('28c65df4', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=28c65df4", function () {
      api.rerender('28c65df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/components/Loading.vue"
export default component.exports